/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AptosNetflowEcosysChainRequest } from '../models/AptosNetflowEcosysChainRequest';
import type { AptosNetflowEcosystemFlowChainInfo } from '../models/AptosNetflowEcosystemFlowChainInfo';
import type { AptosNetflowEcosystemFlowTokenInfo } from '../models/AptosNetflowEcosystemFlowTokenInfo';
import type { AptosNetflowEcosysTokenRequest } from '../models/AptosNetflowEcosysTokenRequest';
import type { AptosNetflowTopRankInfo } from '../models/AptosNetflowTopRankInfo';
import type { AptosNetflowTopRankNetflowRequest } from '../models/AptosNetflowTopRankNetflowRequest';
import type { AptosNetflowTopRankRequest } from '../models/AptosNetflowTopRankRequest';
import type { AptosNetflowTopRankTotalInfo } from '../models/AptosNetflowTopRankTotalInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class NetflowControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getNetflowTopRankOutflow({
        requestBody,
    }: {
        requestBody: AptosNetflowTopRankRequest,
    }): CancelablePromise<AptosNetflowTopRankInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/netflow/top-rank/outflow',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getNetflowTopRankNetflow({
        requestBody,
    }: {
        requestBody: AptosNetflowTopRankNetflowRequest,
    }): CancelablePromise<AptosNetflowTopRankTotalInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/netflow/top-rank/netflow',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getNetflowTopRankInflow({
        requestBody,
    }: {
        requestBody: AptosNetflowTopRankRequest,
    }): CancelablePromise<AptosNetflowTopRankInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/netflow/top-rank/inflow',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getNetflowTokenList({
        requestBody,
    }: {
        requestBody: AptosNetflowEcosysTokenRequest,
    }): CancelablePromise<AptosNetflowEcosystemFlowTokenInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/netflow/ecosystem/token',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getNetflowChainList({
        requestBody,
    }: {
        requestBody: AptosNetflowEcosysChainRequest,
    }): CancelablePromise<AptosNetflowEcosystemFlowChainInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/netflow/ecosystem/chain',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
